import styled from 'styled-components';
import { WHITE_COLOR, DARK_GREY_COLOR } from '../../config/colors';

const Wrapper = styled.div`
	position: relative;
	width: 100vw;
	height: 100vh;

	.auth-wrapper {
		display: flex;
		justify-content: center;
		position: absolute;
		z-index: 10;
		left: 0;
		top: 0;
		bottom: 0;
		width: 33%;
		height: 100%;
		padding: 20px;
		background-color: #29292C;

		.auth-wrapper-container {
			margin: auto;
		}
		.auth-children {
			width: 425px;
			justify-content: center !important;
		}
		.dash-logo {
			padding: 30px 0 40px;
			text-align: center;
			img {
				width: 32px;
			}
		}
		.auth-footer {
			font-size: 12px;
			letter-spacing: -0.2px;
			white-space: nowrap;
			color: #A8A8B1;
			position: absolute;
			left: 0;
			bottom: 40px;
			width: 100%;
			text-align: center;
			p {
				line-height: 1.6;
				margin-bottom: 0;
			}
			a {
				color: #A8A8B1;
			}
			.dash-line {
				display: inline-block;
				width: 75px;
				height: 1px;
				margin: 4px 0;
				background-color: rgb(168 168 177 / 50%);
			}
		}
	}
	.bg-wrapper {
		position: absolute;
		z-index: 1;
		right: 0;
		left: 33%;
		top: 0;
		bottom: 0;
		h2 {
			margin-bottom: 0;
		}
	}
	@media (max-width: 1400px) {
		.auth-children {
			.auth-footer {
				font-size: 10px;
			}
		}
	}
	@media (max-width: 1200px) {
		.auth-wrapper {
			width: 40% !important;
		}
		.auth-children {
			width: 40%;
			.auth-footer {
				font-size: 8px;
			}
			.auth-footer {
				position: static;
				padding-top: 10vh;
			}
		}
		.bg-wrapper {
			left: 40%;
		}
	}
	@media (max-width: 1025px) {
		.auth-wrapper {
			width: 100% !important;
		}
		.auth-children {
			width: 100% !important;
			max-width: none;
		}
		.bg-wrapper {
			display: none;
		}
	}
	@media (max-width: 650px) {
		.auth-wrapper {
			padding: 0px;
		}
		.auth-children {
			padding: 10px;
		}
	}
`;

const HollaExWrapper = styled.div`
	.bg-wrapper-text {
		width: 100%;
		height: 300px;
		position: relative;
		box-sizing: border-box;
		background-color: #0a0a0a;
		padding-top: 130px;
		text-align: center;
		.bg-wrapper-logo {
			margin-bottom: 5px;
			img {
				height: 38px;
			}
		}
		h2 {
			font-size: 32px;
			color: ${WHITE_COLOR};
			font-weight: bold;
		}
		p {
			font-size: 16px;
			color: ${DARK_GREY_COLOR};
		}

		&::before {
			content: '';
			display: block;
			position: absolute;
			width: 100%;
			height: 40px;
			bottom: -40px;
			left: 0;
			background-image: linear-gradient(#0a0a0a, transparent);
		}
		.btn-link {
			color: ${WHITE_COLOR};
			font-size: 10px;
			padding: 7px 14px;
			border: 2px solid ${WHITE_COLOR};
			text-decoration: none;
			font-weight: bold;
		}
	}
	.btn-link:hover {
		opacity: 0.5;
	}
	.myVideo {
		top: 0;
		padding: none;
		}
	.player {
		/* height:100 */
		position: absolute;
	}
	
	a {
		border: 1px solid #A8A8B1;
		padding: 6px;
		font-size:10px;
		color: #fff;
		text-decoration:none !important;
	}
	.bg-wrapper-txt {
		position: absolute;
		top: 50%;
		text-align: center;
		.bg-wrapper-logo {
			margin-bottom: 5px;
			img {
				height: 38px;
			}
		}
		h2 {
			font-size: 32px;
			color: ${WHITE_COLOR};
			font-weight: bold;
		}
		p {
			font-size: 16px;
			color: ${DARK_GREY_COLOR};
		}
	}
	.bg-center-left {
		text-align: center !important;
		position: fixed;
		top: 40%;
		margin-right: 20%;
		.bg-wrapper-logo {
			margin-bottom: 5px;
			img {
				height: 35px;
			}
		}
		h2 {
			font-size: 25px !important;
			color: ${WHITE_COLOR} ;
			font-weight: bold !important;
		}
		p {
			font-size: 12px !important;
			color: ${DARK_GREY_COLOR};
		}
		a {
			font-size: 10px !important;
			padding: 6px;
		}
	}
	.unleash-content {
		top: 35% !important;
		margin-left: 30% !important;
	}
	.bg-center-right {
		text-align: center !important;
		position: fixed;
		top: 40%;
		margin-left: 20%;
		.bg-wrapper-logo {
			margin-bottom: 5px;
			img {
				height: 35px;
			}
		}
		h2 {
			font-size: 20px !important;
			color: ${WHITE_COLOR} ;
			font-weight: bold !important;
		}
		p {
			font-size: 11px !important;
			color: ${DARK_GREY_COLOR};
		}
	}
	.bg-mid-center {
		top: 38% !important;
	}
	.bg-center {
		text-align: center !important;
		position: fixed;
		top: 42% ;
		.bg-wrapper-logo {
			margin-bottom: 5px;
			img {
				height: 35px;
			}
		}
		h2 {
			font-size: 21px !important;
			color: ${WHITE_COLOR};
			font-weight: bold !important;
		}
		p {
			font-size: 13px !important;
			color: ${DARK_GREY_COLOR};
		}
	}
	.bg-top-center {
		text-align: center !important;
		position: fixed;
		top: 40px !important;
		.bg-wrapper-logo {
			margin-bottom: 5px;
			img {
				height: 35px;
			}
		}
		h2 {
			font-size: 23px !important;
			color: ${WHITE_COLOR};
			font-weight: bold !important;
		}
		p {
			font-size: 11px !important;
			color: ${DARK_GREY_COLOR};
		}
	}
	.bg-bottom-center {
		text-align: center !important;
		position: fixed;
		bottom: 55px !important;
		.bg-wrapper-logo {
			margin-bottom: 5px;
			img {
				height: 35px;
			}
		}
		h2 {
			font-size: 23px !important;
			color: ${WHITE_COLOR} ;
			font-weight: bold !important;
		}
		p {
			font-size: 13px !important;
			color: ${DARK_GREY_COLOR};
		}
	}
	.bg-bottom-right-image {
		text-align: right !important;
		position: relative;
		margin-left: auto;
		margin-top: calc(100vh - 170px);
		right: 5px !important;
		.bg-wrapper-logo {
			margin-bottom: 5px;
			img {
				height: 35px;
				margin-right: 20px !important;
			}
		}
		h2 {
			font-size: 20px !important;
			color: ${WHITE_COLOR} ;
			font-weight: bold !important;
			margin-right: 20px !important;
		}
		p {
			font-size: 11px !important;
			color: ${DARK_GREY_COLOR};
			margin-right: 20px !important;
		}
		a {
			margin-right: 20px !important;
		}
	}
	.bg-wrapper-image {
		width: 100%;
		height: 100vh;
		background-position: center;
		background-size: cover;
		padding-top: 130px;
		text-align: center;
		.bg-wrapper-logo {
			margin-bottom: 5px;
			img {
				height: 38px;
			}
		}
		h2 {
			font-size: 32px;
			color: ${WHITE_COLOR};
			font-weight: bold;
		}
		p {
			font-size: 16px;
			color: ${DARK_GREY_COLOR};
		}
	}
	@media (max-width: 1200px) {
		.bg-wrapper-text {
			h2 {
				font-size: 24px;
			}
		}
	}
	.bg-wrapper-parent {
		display: flex;
		justify-content: center;
		position: relative;
	}
	@keyframes keyName-long {
		0% { opacity:0; transform: scale(0.95);}
		100% {transform: scale(1); opacity:1;}
	}
	@keyframes keyName {
		0% { opacity:0; }
		100% {transform: scale(1.02); opacity:1;}
	}
	@keyframes mymove-top {
		from {bottom: -10px; opacity:0;}
		to {bottom: 0px; opacity:1;}
	}
	@keyframes mymove-center-bottom {
		from {top: -10px;opacity:0;}
		to {top: 0px;opacity:1;}
	}
	@keyframes mymove-bottom {
		from {top: -10px; opacity:0;}
		to {top: 0px; opacity:1;}
	}
	@keyframes mymove-right {
		from {right: -10px; opacity:0}
		to {right: 0px; opacity:1}
	}
	@keyframes mymove-left {
		from {left: -10px; opacity:0}
		to {left: 0px; opacity:1}
	}

	@keyframes fadeIn {
		0%{
			opacity: 0;
		}
		10%{
			opacity: 0.1;
		}
		20%{
			opacity: 0.2;
		}
		30%{
			opacity: 0.3;
		}
		40%{
			opacity: 0.4;
		}
		50%{
			opacity: 0.5;
		}
		70%{
			opacity: 0.7;
		}
		80%{
			opacity: 0.8;
		}
		100%{
			opacity: 1;
		}
	}
`;

export { HollaExWrapper, Wrapper };

